export default {
  state: {
    version: "3.2",
    theme: "light", // light - dark
    contentWidth: "full", // full - boxed
    sidebarCollapsed: false,
    sidebarCollapseButton: true,
    layout: "vertical", // vertical - horizontal
    navigationFull: false,
    navigationBg: false,
    direction: "ltr", // ltr - rtl
  }
}
